export const smartIceLocations = [
  {
    name: 'Pond Inlet',
    latitude: 72.7012,
    longitude: -78.1579,
    maxBounds: [
      [-85.7, 71.5],
      [-73.1, 72.5]
    ],
    zoom: [7]
  },
  {
    name: 'Nain',
    latitude: 56.54,
    longitude: -61.7,
    maxBounds: [[-61, 56], [-62, 57]],
    zoom: [10]
  },
  {
    name: 'Qikiqtarjuaq',
    latitude: 67.558056,
    longitude: -64.024722,
    zoom: [7]
  },
  {
    name: 'Arviat',
    latitude: 61.108056,
    longitude: -94.056944,
    zoom: [10]
  },
  {
    name: 'Iqaluit',
    latitude: 63.748611,
    longitude: -68.519722,
    zoom: [10]
  },
  {
    name: 'Resolute',
    latitude: 74.6975,
    longitude: -94.832222,
    zoom: [10]
  },
  {
    name: 'Arctic Bay',
    latitude: 73.036389,
    longitude: -85.1525,
    zoom: [10]
  },
  {
    name: 'North West River',
    latitude: 53.525367,
    longitude: -60.144944,
    zoom: [10]
  }
]
  // .sort((a, b) => a.name.localeCompare(b.name))

export const arcticCrowdSourceLocations = [
  {
    name: 'Pond Inlet',
    latitude: 68.361667,
    longitude: -133.730556,
    zoom: [7]
  },
  {
    name: 'Iqaluit',
    latitude: 63.748611,
    longitude: -68.519722,
    zoom: [10]
  }
]
.sort((a, b) => a.name.localeCompare(b.name))



// WEBPACK FOOTER //
// ./src/config/locations.js